import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { IComponentFactory } from '../../canvas-render/elements/component-factory.interface';
import { ILogic } from './logic.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

export class ElementLogic implements ILogic {
    protected readonly factoryOptions: InterfaceFactoryOptions<IElementBaseModel>;
    protected readonly component: IComponentFactory;

    protected readonly enable: boolean;

    public constructor(factoryOptions: InterfaceFactoryOptions<IElementBaseModel>, component: IComponentFactory) {
        this.factoryOptions = factoryOptions;
        this.component = component;
        this.enable = true;
    }

    public init(): void {
        // 初始化
        this.factoryOptions.model.addStateForRegion?.(this.factoryOptions.region);
    }

    public dispose(): void {
        // 释放资源
        this.factoryOptions.model.removeStateForRegion?.(this.factoryOptions.region);
    }
}
